import React from 'react'
import {
  Modal,
  Button,
  ModalInjectedProps,
  ButtonVariant,
} from '@sketch/components'

export interface ModalConfirmationProps extends ModalInjectedProps {
  title: string
  description: string
  onConfirm: () => void
  didCancel?: () => void
  cancelText?: string
  confirmText: string
  variant?: ButtonVariant
  icon?: React.ReactNode
  loading?: boolean
}

export const ModalConfirmation: React.FCC<ModalConfirmationProps> = ({
  title,
  description,
  hideModal,
  onConfirm,
  cancelText = 'Cancel',
  didCancel = () => {},
  confirmText,
  variant = 'negative',
  loading = false,
}) => {
  const onCancel = () => {
    hideModal()
    didCancel()
  }

  return (
    <Modal onCancel={onCancel}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button variant={variant} onClick={onConfirm} loading={loading}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
